import { render, staticRenderFns } from "./AcademyStudents.vue?vue&type=template&id=d0453d86&scoped=true&lang=pug&"
import script from "./AcademyStudents.vue?vue&type=script&lang=ts&"
export * from "./AcademyStudents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0453d86",
  null
  
)

export default component.exports